import { Images } from '../Model/IotDomainModel';
import '../Styles/IotDomainStyles.css'
import IOTLanding from '../../../../../assets/image/Domains/IOT/iot_home.webp'
import IOTFeatures from '../../../../../assets/image/Domains/IOT/iot_features.webp'
import IOTApplications from '../../../../../assets/image/Domains/IOT/iot_applications.webp'
import IOTLandingMobile from '../../../../../assets/image/Domains/IOT/iot_home_mobile.webp'
import IOTFeaturesMobile from '../../../../../assets/image/Domains/IOT/iot_features_mobile.webp'
import IOTApplicationsMobile from '../../../../../assets/image/Domains/IOT/iot_applications_mobile.webp'
import { useEffect, useState } from 'react';


const IotDomainView = () => {
    const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 1024);

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 1024;
            setIsMobile(mobile);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className='iot-domain-main-page-view-main-container'>
            {!isMobile ? (
                <>
                    <img src={IOTLanding} alt='' style={{ width: '70%', objectFit: "cover" }} />
                    <span className='iot-domain-page-view-main-container-features-heading'>AI POWERED, SMART CONTROL, <span className='primary-color-heading'> SMART AUTOMATION</span></span>
                    <img src={IOTFeatures} alt='' style={{ width: '70%', objectFit: "cover" }} />
                    <span className='iot-domain-page-view-main-container-features-heading'>RUGEDGE SECURE INDUSTRIAL <span className='primary-color-heading'>EDGE INFRASTRUCTURE </span></span>
                    <img src={IOTApplications} alt='' style={{ width: '70%', objectFit: "cover" }} />
                </>) :
                (
                    <>
                        <span className='iot-domain-page-view-main-container-features-heading'>IoT/IIoT SMART  <span className='primary-color-heading'>  AUTOMATION</span></span>
                        <img src={IOTLandingMobile} alt='' style={{ width: '100%', objectFit: "cover" }} />
                        <span className='iot-domain-page-view-main-container-features-heading'>AI POWERED, SMART CONTROL, <span className='primary-color-heading'><br/> SMART AUTOMATION</span></span>

                        <img src={IOTFeaturesMobile} alt='' style={{ width: '100%', objectFit: "cover" }} />
                        <span className='iot-domain-page-view-main-container-features-heading'>RUGEDGE SECURE INDUSTRIAL <span className='primary-color-heading'><br/>EDGE INFRASTRUCTURE </span></span>
                        <img src={IOTApplicationsMobile} alt='' style={{ width: '100%', objectFit: "cover" }} />
                    </>
                )}
        </div>
    )
}

export default IotDomainView;